const CButton=({ data, onClick, loading,buttontext })=>{
    return (
        <button
            type="button"
            className="btn btn-outline-danger btn-sm d-flex align-items-center gap-2"
            disabled={loading}
            onClick={() => onClick(data)}
        >
            {loading ? (
                <>
                    <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                    ></span>
                    Cancelling...
                </>
            ) : (
                <>
                    <i className="bi bi-x-circle"></i>
                    {buttontext}
                </>
            )}
        </button>
    );
};
export default CButton;